
import Vue from 'vue'
import projectDebug from './project'

Vue.use(projectDebug)

export default {
    ...projectDebug,
}



// WEBPACK FOOTER //
// ./src/common/utils/index.js